import { render } from "./PlanoCorretor.vue?vue&type=template&id=aa923eae&scoped=true"
import script from "./PlanoCorretor.vue?vue&type=script&lang=js"
export * from "./PlanoCorretor.vue?vue&type=script&lang=js"

import "./PlanoCorretor.vue?vue&type=style&index=0&id=aa923eae&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa923eae"]])

export default __exports__